// extracted by mini-css-extract-plugin
export var modal = "_iw-0";